import { forEach } from 'lodash';
import { change } from 'redux-form';

import { POST_FORM_NAME } from '../services/post-form-settings';

export const submitPostSettings = (values) => (dispatch) => {
  forEach(values, (value, fieldName) => dispatch(change(POST_FORM_NAME, fieldName, value)));
};
